// ESF OTOMOTİV - Gerçek Ürün Görselleri

export const PRODUCT_IMAGES = {
  // Honlama Kafaları
  "honing-heads": [
    {
      id: "2-pimli-kisa-ayak",
      name: "2 Pimli Kısa Ayak",
      image: "/images/products/2 PİMLİ KISA AYAK.jpeg",
      category: "Honlama Kafaları"
    },
    {
      id: "2-pimli-manuel-ayak",
      name: "2 Pimli Manuel Ayak",
      image: "/images/products/2 PİMLİ MANUEL AYAK.jpeg",
      category: "Honlama Kafaları"
    },
    {
      id: "2-pimli-manuel-honlama",
      name: "2 Pimli Manuel Honlama Kafası",
      image: "/images/products/2 PİMLİ MANUEL HONLAMA KAFASI.jpeg",
      category: "Honlama Kafaları"
    },
    {
      id: "2-pimli-otomatik-honlama",
      name: "2 Pimli Otomatik Honlama",
      image: "/images/products/2 PİMLİ OTOMATİK HONLAMA.jpeg",
      category: "Honlama Kafaları"
    },
    {
      id: "3-pimli-kisa-ayak",
      name: "3 Pimli Kısa Ayak",
      image: "/images/products/3 PİMLİ KISA AYAK.jpeg",
      category: "Honlama Kafaları"
    },
    {
      id: "3-pimli-manuel-honlama",
      name: "3 Pimli Manuel Honlama Kafası",
      image: "/images/products/3 PİMLİ MANUEL HONLAMA KAFASI.jpeg",
      category: "Honlama Kafaları"
    },
    {
      id: "3-pimli-otomatik-honlama",
      name: "3 Pimli Otomatik Honlama Kafası",
      image: "/images/products/3 PİMLİ OROMATİK HONLAMA KAFASI.jpeg",
      category: "Honlama Kafaları"
    },
    {
      id: "3-pimli-uzun-ayak",
      name: "3 Pimli Uzun Ayak",
      image: "/images/products/3 PİMLİ UZUN AYAK.jpeg",
      category: "Honlama Kafaları"
    },
    {
      id: "manuel-honlama-frezeli",
      name: "Manuel Honlama Frezeli Mili",
      image: "/images/products/MANUEL HONLAMA FREZELİ MİLİ.jpeg",
      category: "Honlama Kafaları"
    },
    {
      id: "otomatik-honlama-frezeli",
      name: "Otomatik Honlama Frezeli Mil",
      image: "/images/products/OTOMATİK HONLAMA FREZELİ MİL.jpeg",
      category: "Honlama Kafaları"
    },
    {
      id: "seyyar-honlama",
      name: "Seyyar Honlama",
      image: "/images/products/SEYYAR HONLAMA.jpeg",
      category: "Honlama Kafaları"
    }
  ],

  // Raybalar
  "reamers": [
    {
      id: "ayarli-rayba",
      name: "Ayarlı Rayba",
      image: "/images/products/ayarlı rayba.jpeg",
      category: "Raybalar"
    },
    {
      id: "hss-raybalar",
      name: "HSS Raybalar",
      image: "/images/products/hss raybalar.jpeg",
      category: "Raybalar"
    },
    {
      id: "karbur-rayba",
      name: "Karbür Rayba",
      image: "/images/products/karbür rayba.jpeg",
      category: "Raybalar"
    },
    {
      id: "konik-rayba",
      name: "Konik Rayba",
      image: "/images/products/konik rayba.jpeg",
      category: "Raybalar"
    }
  ],

  // Test ve Ölçü Aletleri
  "measuring-tools": [
    {
      id: "duz-mastar",
      name: "Düz Mastar",
      image: "/images/products/düz mastar.jpeg",
      category: "Test ve Ölçü Aletleri"
    },
    {
      id: "elektrikli-vakummetre",
      name: "Elektrikli Vakummetre",
      image: "/images/products/elektirkli vakummetre.jpeg",
      category: "Test ve Ölçü Aletleri"
    },
    {
      id: "komparator-saati",
      name: "Komparatör Saati",
      image: "/images/products/komparatör saati.jpeg",
      category: "Test ve Ölçü Aletleri"
    },
    {
      id: "kumpas",
      name: "Kumpas",
      image: "/images/products/kumpas.jpeg",
      category: "Test ve Ölçü Aletleri"
    },
    {
      id: "mikro-metre",
      name: "Mikrometre",
      image: "/images/products/mikro metre.jpeg",
      category: "Test ve Ölçü Aletleri"
    },
    {
      id: "piston-olcme",
      name: "Piston Ölçme",
      image: "/images/products/piston ölçme.jpeg",
      category: "Test ve Ölçü Aletleri"
    },
    {
      id: "saatli-mastar",
      name: "Saatli Mastar",
      image: "/images/products/saatli mastar.jpeg",
      category: "Test ve Ölçü Aletleri"
    },
    {
      id: "silindir-komparatoru",
      name: "Silindir Komparatörü",
      image: "/images/products/silindir komparatörü.jpeg",
      category: "Test ve Ölçü Aletleri"
    },
    {
      id: "yukseklik-olcme",
      name: "Yükseklik Ölçme",
      image: "/images/products/yükseklik ölçme.jpeg",
      category: "Test ve Ölçü Aletleri"
    }
  ],

  // Polisaj Makinası
  "polishing": [
    {
      id: "devir-ayarli-polisaj",
      name: "Devir Ayarlı Polisaj Makinası",
      image: "/images/products/DEVİR AYARLI polisaj makinası1.jpeg",
      category: "Polisaj Makinası"
    },
    {
      id: "polisaj-makinasi",
      name: "Polisaj Makinası",
      image: "/images/products/polisaj makinası.jpeg",
      category: "Polisaj Makinası"
    }
  ],

  // Yıkama Makinaları
  "washing-machines": [
    {
      id: "1000l-yikama",
      name: "1000L Yıkama Makinası",
      image: "/images/products/1000LİK YIKAMA MAKİNASI.jpeg",
      category: "Yıkama Makinaları"
    },
    {
      id: "1250l-yikama",
      name: "1250L Yıkama Makinası",
      image: "/images/products/1250LİK YIKAMA MAKİASI.jpeg",
      category: "Yıkama Makinaları"
    },
    {
      id: "1500l-yikama",
      name: "1500L Yıkama Makinası",
      image: "/images/products/1500LÜK YIKAMA MAİNASI.jpeg",
      category: "Yıkama Makinaları"
    }
  ],

  // Subap Taşlama Makinası
  "valve-grinding": [
    {
      id: "subap-taslama",
      name: "Subap Taşlama Makinası",
      image: "/images/products/SUBAP TAŞLAMA MAKİNASI.jpeg",
      category: "Subap Taşlama Makinası"
    }
  ]
};

// Kategori ID'sine göre görselleri getiren yardımcı fonksiyon
export const getImagesByCategory = (categoryId) => {
  return PRODUCT_IMAGES[categoryId] || [];
};

// Tüm görselleri tek bir array olarak getiren fonksiyon
export const getAllImages = () => {
  return Object.values(PRODUCT_IMAGES).flat();
};